module.exports = __webpack_public_path__ + "img/up.5dd6ec48.png";